import { DayDepthChartWidgetEntity } from 'src/pages/dashboard/features/well-day-depth-widget/DayDepthChartWidget.entity';
import { parseDayDepthChartWidgetInternalState } from 'src/pages/dashboard/features/well-day-depth-widget/parseDayDepthChartWidget';
import type { TSerializedWidgetTemplate } from 'src/pages/dashboard/features/workspace/Workspace.store';

export function mapDayDepthChartTemplate(
  template: TSerializedWidgetTemplate,
  index: number,
  options?: { wellId: number | null },
): DayDepthChartWidgetEntity {
  const { size, position } = template;

  const internalState = parseDayDepthChartWidgetInternalState(template.internalState ?? {});

  const wellDayDepthWidget = new DayDepthChartWidgetEntity(
    {
      wellId: options?.wellId ?? null,
      stateParams: internalState.stateParams ?? {},
      type: 'time-vs-depth-widget',
    },
    {
      groupId: template.groupId || null,
      isGroupsDefaultOpened: false,
      uuid: template.uuid,
      isPinned: false,
      isFullscreen: false,
      zIndex: index + 1,
      size: {
        w: size.w,
        h: size.h,
      },
      position: {
        x: position.x,
        y: position.y,
      },
    },
  );

  return wellDayDepthWidget;
}
